import { ConcreteEncodable } from "./ConcreteEncodable";

import { SessionInitialiserReponseImplEncoder } from "../../encoder/SessionInitialiserReponseImplEncoder";

import * as CubiqTS from "../../index";
import { SessionInitialiserReponse } from "../SessionInitialiserReponse";

export class SessionInitialiserReponseImpl
  extends ConcreteEncodable
  implements SessionInitialiserReponse
{
  public static enType: string = "com.bcdfx.model.SessionInitialiserReponseImpl";

  /*FID=1*/
  public visibilityProfile: CubiqTS.VisibilityProfile | null = null;
  /*FID=2*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SessionInitialiserReponseImplEncoder.Instance;
    this.setEncodableType(SessionInitialiserReponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SessionInitialiserReponseImpl[" +
      "visibilityProfile=" +
      this.visibilityProfile +
      "secureToken=" +
      this.secureToken +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
